import { IMessageBarProps, MessageBar } from '@fluentui/react';

export interface IPMessageBarProps extends IMessageBarProps {}
export { MessageBarType as IPMessageBarType } from '@fluentui/react';

export const IPMessageBar = (props: IPMessageBarProps) => {
  return <MessageBar {...props} />;
};
